/** Resolve a public/ asset URL respecting Vite base (e.g. /beta/ on marketing deploy). */
export function publicAssetUrl(path: string): string {
  const base = import.meta.env.BASE_URL;
  const normalized = path.replace(/^\//, "");
  return `${base}${normalized}`;
}
